import { lazy } from 'react';

export const PurchaseOrdersList = lazy(() => import('./pages/PurchaseOrdersList'));
export const PurchaseOrderNew = lazy(() => import('./pages/PurchaseOrderNew'));
export const PurchaseOrderDetail = lazy(() => import('./pages/PurchaseOrderDetail'));

export { PURCHASE_ORDER_ROUTES } from './paths';
